const clamp = (num, min, max) => Math.min(Math.max(num, min), max)

export const generateColorShades = (red, green, blue, percent) => {
  let R = Math.round((red * (100 + percent)) / 100)
  let G = Math.round((green * (100 + percent)) / 100)
  let B = Math.round((blue * (100 + percent)) / 100)

  R = clamp(R, 0, 255)
  G = clamp(G, 0, 255)
  B = clamp(B, 0, 255)

  const RR = R.toString(16).padStart(2, '0')
  const GG = G.toString(16).padStart(2, '0')
  const BB = B.toString(16).padStart(2, '0')

  return `#${RR}${GG}${BB}`
}
